module.exports = __webpack_public_path__ + "static/media/portfolio1.56370633.jpeg";